<template>
<div>
  <div class="wistia_embed wistia_async_smc6z9gj27">
    &nbsp;
  </div>

  <span
    id="vid-embeds-1-1"
    class="tbk-vid-embed"
  >
    <a
      id="good-news"
      class="embedded_video"
      href="#wistia_wn823d6xrm?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="bad-news"
      class="embedded_video"
      href="#wistia_rjcjugqzf7?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </span>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('smc', 14, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        wn8: this.tbk.autoPlay,
        rjc: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#vid-embeds-1-1
  display: none
  background-image: url('~./diabetes-1_1_news.jpg')
  a
    text-decoration: none
#good-news
  position: absolute
  top: calc(100% * (145 / 360))
  left: calc(100% * (28 / 640))
  width: calc(100% * (275 / 640))
  height: calc(100% * (160 / 360))
#bad-news
  position: absolute
  top: calc(100% * (145 / 360))
  left: calc(100% * (335 / 640))
  width: calc(100% * (275 / 640))
  height: calc(100% * (160 / 360))
</style>
